import { render } from "./RegistrationUserStepTwo.vue?vue&type=template&id=5f8ff7f6&scoped=true"
import script from "./RegistrationUserStepTwo.vue?vue&type=script&lang=js"
export * from "./RegistrationUserStepTwo.vue?vue&type=script&lang=js"

import "./RegistrationUserStepTwo.vue?vue&type=style&index=0&id=5f8ff7f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8ff7f6"]])

export default __exports__